<template>
  <div class="list-details list-light texture-light-bg-css">
    <div
      v-if="isWechart && showWMask && !isMiniprogram"
      class="wechart-mask absolute pin-x pin-y"
      @click="showWMask = false"
    >
      <img
        src="../../../static/images/public/arrow-share.png"
        class="absolute pin-t pin-r"
        alt="share"
      />
    </div>

    <div class="w">
      <div class="page-header"><Breadcrumb class="deep-breadcrumb" /></div>
      <div
        v-if="details"
        class="lists-content light-flower-bg relative cursor-default"
      >
        <h4 class="text-center info-title">
          {{ details.title }}
          <div v-if="details.published_at" class="time">
            {{ details.published_at.slice(0, 10) }}
            <span v-if="details.author">
              &emsp;作者：{{ details.author || '无' }}
            </span>
          </div>
        </h4>
        <div class="text-center info-videos">
          <div v-if="video" class="info-video relative clearfix">
            <VideoPlayer
              class="video"
              v-if="details"
              :data="details"
              type="video"
            ></VideoPlayer>
          </div>
          <div
            v-else-if="videoAttachments.length > 0"
            class="info-video relative clearfix"
          >
            <VideoPlayer
              class="video"
              v-for="detail in videoAttachments"
              :key="'videoAttachments_' + detail.id"
              :data="detail"
              :ref="`video${detail.id}`"
            ></VideoPlayer>
          </div>
        </div>
        <HtmlViewer
          class="info-content"
          :emptyText="'暂无数据'"
          :content="video ? details.description : details.html"
        ></HtmlViewer>
        <div
          v-if="details.attributes && details.attributes.source"
          class="time text-right pt-0"
        >
          来源：{{ details.attributes.source || '无' }}
        </div>
        <div
          v-if="
            !isMiniprogram &&
              details.attachments &&
              details.attachments.length !== 0
          "
          class="info-attachment"
        >
          <ul class="info-attachment-list">
            <li
              v-for="attachment in details.attachments"
              :key="attachment.id"
              @click="download(attachment)"
              :class="attachment.type === 'video' ? 'hidden' : ''"
            >
              <div class="info-attachment-li clearfix">
                <i class="s-circular"></i>
                <!-- <span class="info-attachment-li-icon"></span> -->
                {{ attachment.title }}
                <!-- <span class="info-attachment-li-size float-right"
                  >{{
                    attachment.file.size > 1024
                      ? (attachment.file.size / 1024).toFixed(2) + ' M'
                      : attachment.file.size + ' k'
                  }}
                </span> -->
              </div>
            </li>
          </ul>
        </div>
        <div v-if="details" class="btns">
          <div
            class="btn btn-top cursor-pointer"
            :class="{ active: toTopActive, mini: isMiniprogram }"
            id="toTop"
            @click="toTop(0)"
            @touchstart="toTopActive = true"
            @touchend="toTopActive = false"
          ></div>
          <div v-if="showView">
            <div
              v-if="!video && (!isMobile || isMiniprogram)"
              class="btn btn-follow cursor-pointer"
              :class="{ active: isFollow || collected, mini: isMiniprogram }"
              @click="collection"
            ></div>
          </div>

          <share
            v-if="!isMiniprogram"
            class="relative social-share"
            :config="config"
          ></share>
        </div>
      </div>
      <div v-else class="text-center no-data light-flower-bg">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Breadcrumb from '@/components/common/Breadcrumb'
import VideoPlayer from '@/components/common/Video'
import HtmlViewer from '@/components/common/HtmlViewer'

import { getArticle, getVideo, download, collectArticle } from '@/core/api'
import EventBus from '@/core/eventbus'
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import wx from 'weixin-js-sdk'
Vue.use(Share)

export default {
  name: 'list-details',
  components: {
    Breadcrumb,
    VideoPlayer,
    HtmlViewer
  },
  watch: {
    '$route.fullPath'() {
      this.setConfig()
    }
  },
  data() {
    return {
      id: null,
      category: null,
      details: null,
      showShare: false,
      play: true,
      config: {
        url: '', // 网址，默认使用 window.location.href
        // source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: '御窑厂文章赏析', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: '/img/logo.bafc600c.png', // 图片, 默认取网页中第一个img标签
        sites: ['weibo', 'wechat'], // 启用的站点
        // disabled: ['qzone', 'qq','google', 'facebook', 'twitter', 'douban'], // 禁用的站点
        // wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
        wechatQrcodeHelper:
          '<p>打开微信“扫一扫”，</p><p>打开网页后点击屏幕右上角分享按钮</p>'
      },
      toTopActive: false,
      showWMask: true,
      isFollow: null,
      showView: true
    }
  },
  computed: {
    video() {
      return this.category === 'video'
    },
    videoAttachments() {
      let arr = []
      if (this.details && this.details.attachments) {
        arr = this.details.attachments
        arr = arr.filter(item => item.type === 'video')
      }
      return arr
    },
    collected() {
      let res
      if (typeof this.isFollow === 'boolean') {
        // alert(this.isFollow)
        res = this.isFollow
      } else if (this.isMiniprogram) {
        res =
          this.$route.query.isFollow && this.$route.query.isFollow === 'true'
      } else {
        let data = this.$store.getters['SubscriberStore/articlesCollections']
        let collect = []
        if (data && this.id) {
          collect = data.filter(item => item.id === this.id - 0)
        }
        res = collect.length > 0 ? true : false
      }
      return res
    },
    isLogin() {
      let subscriber = this.$store.getters['SubscriberStore/subscriber']
      let client = this.$store.getters['SubscriberStore/client']
      return subscriber && client && subscriber.open_id && client.mobile
    },
    isMobile() {
      let res = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return res
    },
    isWechart() {
      // Js获取User-Agent
      var ua = navigator.userAgent
      var isWeixin = !!/MicroMessenger/i.test(ua)
      return isWeixin
    },
    isMiniprogram() {
      return (
        navigator.userAgent.match(/miniprogram/i) ||
        window.__wxjs_environment === 'miniprogram'
      )
    }
    // isIOS() {
    //   var u = navigator.userAgent
    //   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    //   return isiOS
    // }
  },
  mounted: function() {
    this.id = this.$route.query.id // 从地址栏拿文章ID
    this.category = this.$route.params.category // 从地址栏拿栏目的ID
    this.getDetails()

    this.$nextTick(function() {
      this.wechatHtml()
    })
  },
  methods: {
    wechatHtml() {
      if (this.isMobile) {
        let wechatQrcode = document.getElementsByClassName('wechat-qrcode')
        if (!wechatQrcode || wechatQrcode.length === 0) {
          let timer = setTimeout(() => {
            this.wechatHtml()
            clearTimeout(timer)
          }, 0)
          return
        }
        wechatQrcode[0].innerHTML =
          '<h4>微信分享</h4><div class="help"><img src="data:image/png;base64,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" alt="icon"/><p>请使用浏览器的微信分享功能，</p><p>进行分享！</p></div>'
      }
    },
    toTop(position) {
      // 不存在原生`requestAnimationFrame`，用`setTimeout`模拟替代
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(cb) {
          return setTimeout(cb, 17)
        }
      }
      // 当前滚动高度
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // step
      var step = function() {
        var distance = position - scrollTop
        scrollTop = scrollTop + distance / 5
        if (Math.abs(distance) < 1) {
          window.scrollTo(0, position)
        } else {
          window.scrollTo(0, scrollTop)
          requestAnimationFrame(step)
        }
      }
      step()
    },
    setConfig() {
      this.config.url = JSON.parse(JSON.stringify(window.location.href))
      this.config.title = JSON.parse(JSON.stringify(this.details.title))
      this.config.image = JSON.parse(
        JSON.stringify(this.$store.getters['HomeStore/logoUrl'])
      )
      this.config.description = JSON.parse(JSON.stringify(this.details.title))
    },
    async collection() {
      if (this.isMiniprogram && this.$route.query.isLogin === 'false') {
        // 小程序未登录状态
        this.$swal({
          position: 'top-end',
          type: 'error',
          toast: true,
          text: '暂无收藏权限！登录后可继续！',
          showConfirmButton: false,
          timer: 3000
        })
        return false
      }
      let _this = this
      let headers, res
      if (this.isMiniprogram) {
        headers = {
          'WX-ORIGINAL-ID': this.$route.query.originalId,
          'WX-OPEN-ID': this.$route.query.openid
        }
      } else if (!this.isLogin) {
        EventBus.$emit('showModal')
        return
      }

      try {
        if (this.isMiniprogram) {
          res = await collectArticle(_this.category, _this.id, headers)
          _this.$set(_this, 'isFollow', !_this.collected)
          wx.miniProgram.postMessage({
            data: {
              id: _this.$route.query.id,
              favorite: _this.isFollow
            }
          })
          _this.showView = false // 通过v-if移除router-view节点
          _this.$nextTick(() => {
            _this.showView = true // DOM更新后再通过v-if添加router-view节点
          })
          // alert(_this.isFollow)
        } else {
          res = await collectArticle(_this.category, _this.id)
          _this.$store.dispatch('SubscriberStore/fetch') // 获取个人信息
        }
        this.$swal({
          position: 'top-end',
          type: 'success',
          toast: true,
          text: res.data,
          showConfirmButton: false,
          timer: 3000
        })
      } catch (e) {
        this.$swal({
          position: 'top-end',
          type: 'error',
          toast: true,
          text: '操作失败',
          showConfirmButton: false,
          timer: 3000
        })
      }
    },
    async getDetails() {
      // 获取详情数据
      if (this.video) {
        let res = await getVideo(this.category, this.id)
        // console.log(res) // eslint-disable-line no-console
        if (res.status === 200) {
          this.details = res.data
          this.setConfig()
        }
      } else {
        let res = await getArticle(this.category, this.id)
        // console.log(res) // eslint-disable-line no-console
        if (res.status === 200) {
          this.details = res.data
          this.setConfig()
        }
      }
    },
    async download(log) {
      // console.log(log) // eslint-disable-line no-console
      let res = await download(this.category, this.id, log.id)
      if (res.status === 200) {
        window.location.href = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.list-details {
  padding-bottom: 80px;
  .lists-content {
    padding: 60px 85px;
    margin-top: 30px;
  }
  .info-title {
    line-height: 1.4;
    font-size: 30px;
    font-weight: 400;
    color: $c-breadcrumb-deep-font;
    .time {
      padding-top: 35px;
    }
  }
  .time {
    font-size: 14px;
    color: $c-breadcrumb-deep-font;
  }
  .info-videos {
    padding: 50px 0 0;
    height: auto;

    .info-video {
      display: inline-block;
      width: 688px;
    }
    .video {
      width: 100%;
      height: 100%;
      margin-bottom: 48px;
    }
  }
  .pag {
    padding: 60px 0;
  }
  .info-content {
    line-height: 2.1;
    font-size: 16px;
    color: $c-breadcrumb-deep-font;
    text-align: justify;
    padding-bottom: 40px;
    ::v-deep  .paragraph {
      padding-bottom: 34px;
      &:last-child {
        padding-bottom: 0;
      }
    }
    ::v-deep  .info-pic {
      padding-bottom: 30px;
      img {
        width: 688px;
        height: 370px;
      }
    }
  }
  .info-attachment {
    padding-top: 55px;
    .info-attachment-title {
      line-height: 1;
      font-size: 16px;
      color: $c-nav-list;
      padding-bottom: 20px;
      border-bottom: 1px solid $c-f3e9d3;
    }
    .info-attachment-li {
      cursor: pointer;
      display: inline-block;
      line-height: 1.2;
      font-size: 14px;
      color: $c-tour-2;
      text-align: left;
      min-width: 380px;
    }
    .s-circular {
      border-color: $c-tour-2;
      margin-bottom: 0px;
      margin-right: 1px;
    }

    .info-attachment-li-size {
      font-size: 12px;
      color: $c-breadcrumb-deep-font;
      padding-right: 16px;
      background-image: url('../../../static/images/public/download.png');
      background-size: 11px 12px;
      background-repeat: no-repeat;
      background-position: 100% 46%;
    }
  }
  .btns {
    width: 52px;
    height: auto;
    position: fixed;
    top: 50%;
    right: 50%;
    margin-right: -675px;

    .btn {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      line-height: 50px;
      text-align: center;
      margin-bottom: 4px;
      border: 0 none;
      background-color: $c-tour-4;
      background-position: center;
      background-size: auto 48%;
      background-repeat: no-repeat;
      &.active,
      &:hover {
        background-color: $c-tour-2;
      }
    }
    .btn-top {
      background-image: url('../../../static/images/public/top.png');
    }
    .btn-top.mini {
      background-color: rgba(0, 0, 0, 0.54);
      border: 1.2px solid #c1c1c1;
      &:hover,
      &.active {
        background-color: rgba(0, 0, 0, 0.54);
      }
    }
    .btn-follow {
      background-image: url('../../../static/images/public/follow.png');
    }
    .btn-follow.mini {
      background-color: $c-transparent;
      background-size: 100% 100%;
      background-image: url('../../../static/images/gem/gemFollow.svg');
      &:hover,
      &.active {
        background-color: $c-transparent;
      }
      &.active {
        background-image: url('../../../static/images/gem/gemFollowed.svg');
      }
    }
  }
  ::v-deep  .social-share {
    height: 110px;
    .icon-weibo {
      background-image: url('../../../static/images/public/sina-weibo.png');
    }
    .icon-wechat {
      position: absolute;
      left: 0px;
      top: 50px;
      margin-top: 4px;
      background-image: url('../../../static/images/public/WeChat.png');
    }
  }
  ::v-deep  .social-share-icon {
    border-radius: 0;
    margin: 0;
    border: 0 none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin-bottom: 4px;
    background-color: $c-tour-4;
    background-size: auto 48%;
    background-repeat: no-repeat;
    background-position: center;
    &:before {
      content: '';
    }
    &:hover {
      background-color: $c-tour-2;
    }
  }
  ::v-deep  .social-share .icon-wechat .wechat-qrcode {
    left: -79px;
    width: 205px;
  }
}

@media only screen and (min-width: 736px) {
  .wechart-mask {
    display: none;
  }
}
@media only screen and (max-width: 735px) {
  .wechart-mask {
    z-index: 10;
    background-color: $c-transparent-8;
    img {
      width: 58vw;
      margin-right: 3vw;
    }
  }
  .w {
    min-width: 100%;
    width: 100% !important;
  }
  .page-header {
    display: none;
  }
  .list-details {
    min-height: 100vh;
    padding: 5vw;
    .time {
      font-size: 0.8rem;
    }
    .info-title {
      font-size: 1.5rem;
      .time {
        padding-top: 5vw;
      }
    }
    .lists-content {
      margin: 0;
      padding: 5vw;
      font-size: 1rem;
    }
    .info-videos {
      padding: 5vw 0 0;
      .info-video {
        width: 100%;
      }
      .video {
        margin-bottom: 5vw;
      }
    }
    .info-content {
      padding-bottom: 5vw;
    }
    .info-attachment {
      padding-top: 5vw;
      .info-attachment-li {
        min-width: 100%;
        margin: 2vw 0;
      }
    }
    .btns {
      right: 3vw;
      margin-right: 0;
      top: auto;
      bottom: 5%;
      .btn {
        width: 12vw;
        height: 12vw;
        line-height: 12vw;
        margin-bottom: 3vw;
        -webkit-tap-highlight-color: $c-transparent;
        &:hover {
          background-color: $c-tour-4;
        }
        &.active {
          background-color: $c-tour-2;
        }
      }
    }
    ::v-deep  .social-share {
      height: 30vw;
      .social-share-icon {
        width: 12vw;
        height: 12vw;
        line-height: 12vw;
        margin-bottom: 3vw;
      }
      .icon-wechat {
        top: 15vw;
        margin-top: 0;
        .wechat-qrcode {
          width: 50vw;
          height: auto;
          padding-bottom: 1vw;
          left: -59vw;
          top: -50vh;
          &:after {
            display: none;
          }
          h4 {
            height: 7vw;
            line-height: 7vw;
            font-size: 0.8rem;
          }
          .qrcode {
            width: 24vw;
          }
          .help p {
            line-height: 4vw;
          }
        }
      }
    }
  }
}
</style>
